import { isAtlassianEmployee } from './date-time-util/isAtlassianEmployee';

/**
 * Returns true when we should auto-include conversation history and research enrollment
 * in JSM feedback tickets (hide checkboxes from user).
 * Requires: internal user + feature gate ON + debug checkbox (storeUserMessages) ON.
 */
export const isInternalUserWithAutoIncludeHistory = (
	email?: string,
	storeUserMessages?: boolean,
): boolean => !!isAtlassianEmployee(email) && !!storeUserMessages;
